"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const ObfuscationTarget_1 = require("../../enums/ObfuscationTarget");
exports.ObfuscationTargetSanitizer = (value) => {
    const isCorrectTarget = Object
        .keys(ObfuscationTarget_1.ObfuscationTarget)
        .some((key) => {
        return ObfuscationTarget_1.ObfuscationTarget[key] === value;
    });
    if (!isCorrectTarget) {
        throw new ReferenceError('Invalid value of `--target` option');
    }
    return value;
};
